import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Landing/Header/header";
import Footer from "../../components/Landing/Footer/footer";
import Pagination from "rc-pagination";
import { ReactComponent as ShareIcon } from "../../assets/svgs/share.svg";
import { ReactComponent as NextArrow } from "../../assets/svgs/next-arrow.svg";
import { ReactComponent as PrevArrow } from "../../assets/svgs/prev-arrow.svg";
import styles from "./jobs.module.css";
import "rc-pagination/assets/index.css";
import moment from "moment";
import { publicJobs } from "../../services/talentCalls";
import { errorHandler } from "../../utils";
import FullScreenLoader from "../../components/Loaders/FullScreen/loader";
import SearchModal from "../../components/SearchModalClient/searchModal";
const Jobs = () => {
  const navigate = useNavigate();
  const [jobsArr, setJobsArr] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [jobsPerPage] = useState(5);
  const [currentJobs, setCurrentJobs] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);

  const [filters, setFilters] = useState({
    role: "",
    skills: "",
    location: "",
    paymentMin: "",
    paymentMax: "",
    jobTypes: "",
    workModes: "",
    // advancedFilters: true,
  });

  const handleApplyClick = (job) => {
    navigate(`/job-details/${job._id}`, { state: { job } });
  };

  const handleShareClick = async (e, job) => {
    e.preventDefault();
    e.stopPropagation();
    const jobUrl = `${window.location.origin}/job-details/${job._id}`;
    if (navigator.share) {
      await navigator.share({
        title: job.title,
        text: 'Check out this job!',
        url: jobUrl,
      });
    } else {
      await navigator.clipboard.writeText(jobUrl);
      errorHandler('Job link copied to clipboard!', "success");
    }
  };

  const getTimeAgo = (createdAt) => {
    const createdAtMoment = moment(createdAt);
    const now = moment();
    const monthsDiff = now.diff(createdAtMoment, 'months');
    if (monthsDiff > 0) return `${monthsDiff} month${monthsDiff !== 1 ? 's' : ''} ago`;
    const weeksDiff = now.diff(createdAtMoment, 'weeks');
    if (weeksDiff > 0) return `${weeksDiff} week${weeksDiff !== 1 ? 's' : ''} ago`;
    const daysDiff = now.diff(createdAtMoment, 'days');
    return daysDiff === 0 ? 'Today' : `${daysDiff} day${daysDiff !== 1 ? 's' : ''} ago`;
  };

  const fetchJobs = async (pageNum = 1) => {
    setLoading(true);
    setError(null);
    const response = await publicJobs(pageNum);
    if (response.success && response.status === "success") {
      const validRecords = Array.isArray(response.data.records) ? response.data.records : [];
      setJobsArr(validRecords);
      setTotalItems(validRecords.length);
    } else {
      setError(response.message || "No jobs currently available");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  useEffect(() => {
    const indexOfLastJob = page * jobsPerPage;
    const indexOfFirstJob = indexOfLastJob - jobsPerPage;
    setCurrentJobs(jobsArr?.slice(indexOfFirstJob, indexOfLastJob));
  }, [page, jobsArr]);


    const fetchAllJobs = async (pageNum = 1) => {
      setLoading(true);
      try {
        const res = await publicJobs(pageNum, filters);
        if (res?.data.records) {
          setJobsArr(res.data.records);
        };
      } catch (error) {
        error.response?.data
          ? errorHandler(error.response.data.errors, "Error")
          : errorHandler(
              "Network error: Something went wrong, Please check your internet connection and try again.",
              "Error"
            );
      } finally {
        setLoading(false);
      }
    };

  return (
    <div>
      <Header />
      <div className={styles.jobsContainer}>
        {loading ? (
          <FullScreenLoader />
        ) : error ? (
          <div className={styles.errorState}>{error}</div>
        ) : (
          <>
          <span
            className={styles.adSearch}
            onClick={() => setIsSearchModalOpen(true)} // Open modal on click
          >
            Advanced Search
          </span>
            {currentJobs.map((job) => (
              <div key={job._id} className={styles.jobRow}>
                <div className={styles.jobInfo}>
                  <div className={styles.jobTitle}>
                    <h3 className={styles.jobRole}>{job.title}</h3>
                    <p className={styles.jobCompany}>{job.jobType}</p>
                  </div>
                  <div className={styles.jobLocation}>
                    <p>{job.location}</p>
                  </div>
                  <div className={styles.jobEmploymentType}>
                    <p>{job.type} | {job.workMode}</p>
                  </div>
                  <div className={styles.jobDate}>
                    <p>{getTimeAgo(job.createdAt)}</p>
                  </div>
                  <div className={styles.jobSalary}>
                    <p>{job.budget}</p>
                  </div>
                  <div>
                    <ShareIcon
                      className={styles.shareIcon}
                      onClick={(e) => handleShareClick(e, job)}
                    />
                    </div>
                  <div className={styles.jobActions}>
                    <button
                      className={styles.applyButton}
                      onClick={() => handleApplyClick(job)}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            ))}

            {jobsArr?.length < 1 && (
              <div className={styles.noJobs}>
                <h6>No Jobs Found</h6>
              </div>
            )}

            {jobsArr.length > 0 && (
              <div className={styles.paginationContainer}>
                <Pagination
                  pageSize={jobsPerPage}
                  current={page}
                  total={jobsArr.length}
                  onChange={(page) => {
                    setPage(page);
                    window.scrollTo(0, 0);
                  }}
                  nextIcon={<NextArrow />}
                  prevIcon={<PrevArrow />}
                  showTitle={false}
                />
              </div>
            )}
          </>
        )}


        {isSearchModalOpen && (
          <SearchModal
            setModalOpen={setIsSearchModalOpen}
            setFilters={setFilters}
            filters={filters}
            handleSearchFilters={fetchAllJobs}
          />
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Jobs;